export enum CliAuthSessionStatus {
  Pending = 'pending',
  Approved = 'approved',
  Denied = 'denied',
  Expired = 'expired',
}

export interface CliAuthDenyParams {
  sessionId: string;
}

export interface CliAuthDenyResult {
  error?: string;
}

export interface CliAuthInitParams {}

export interface CliAuthInitResult {
  sessionId?: string;
  error?: string;
}

export interface CliAuthApproveParams {
  sessionId: string;
  refreshToken: string;
}

export interface CliAuthApproveResult {
  error?: string;
}

export interface CliAuthStatusParams {
  sessionId: string;
  peek?: boolean;
}

export interface CliAuthStatusResult {
  status: CliAuthSessionStatus;
  idToken?: string;
  refreshToken?: string;
  error?: string;
}
